import React from 'react';

export interface AppModeContextProps {
  RETAIL_MODE: boolean,
  TRADING_MODE: boolean
}

const AppModeContext = React.createContext<Partial<AppModeContextProps>>({
  RETAIL_MODE: false,
  TRADING_MODE: false
});

export default AppModeContext;
